module.exports = __webpack_public_path__ + "img/code-jquery-md.22423c27.webp";